import Vue from "vue";
import Vuex from "vuex";

import User from "./modules/user";
import Quiz from "./modules/quiz";

Vue.use(Vuex);

const Store = new Vuex.Store({
  modules: {
    User,
    Quiz
  }
});

export default Store;
